import * as THREE from 'three'
import Experience from '../Experience.js'

export default class Bracelet
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time

        this.resource = this.resources.items.braceletModel

        this.setModel()
        this.setCamera()
        this.setAnimation()
    }

    setModel()
    {
        this.model = this.resource.scene
        this.scene.add(this.model)
    }

    setCamera()
    {
        const gltfCamera = this.resource.cameras?.[0]
        if(!gltfCamera)
            return

        gltfCamera.aspect = this.experience.sizes.width / this.experience.sizes.height

        const isMobile = window.innerWidth < 768
        if(isMobile)
        {
            gltfCamera.zoom = 0.6
        }

        gltfCamera.updateProjectionMatrix()

        this.experience.camera.setGltfCamera(gltfCamera)
    }

    setAnimation()
    {
        this.animation = {}
        this.animation.mixer = new THREE.AnimationMixer(this.model)
        this.animation.actions = []
        this.animation.duration = 0

        this.resource.animations.forEach((clip) =>
        {
            const action = this.animation.mixer.clipAction(clip)
            action.setLoop(THREE.LoopOnce)
            action.clampWhenFinished = true
            action.play()
            action.paused = true

            this.animation.actions.push(action)
            this.animation.duration = Math.max(this.animation.duration, clip.duration)
        })

        this.scrollProgress = this.experience.scrollProgress
    }

    update()
    {
        this.scrollProgress = this.experience.scrollProgress
        const targetTime = this.scrollProgress * this.animation.duration

        for(const action of this.animation.actions)
        {
            action.time = targetTime
        }

        this.animation.mixer.update(0)
    }
}
